export default __webpack_public_path__ + "static/media/external-vendors.d2ba7c38.svg";